export default function Loading() {
    return <h6 className="loading">Ładowanie...</h6>
}